<template>
    <div class="container">
        <div class="row">
            <div class="col-lg-12" id="infinite_list">
                <div v-show="isFirstLoading === true" class="container loading-skeleton">
                    <div class="row">
                        <div class="col-md-6 col-lg-4" v-for="i in 9" :key="i">
                            <div class="card mb-3">
                                <img src="//placekitten.com/300/200" class="card-img-top rounded-top" alt="...">
                                <div class="card-body rounded-bottom">
                                    <h5 class="card-title">Card title</h5>
                                    <h5 class="card-title">Card title</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-show="isFirstLoading === false" class="row image-title-right">
                    <div v-for="estate in estates" :key="estate.id" class="col-sm-6 col-lg-4 mb-4">
                        <router-link :to="{name: '', params: {id: estate.id}}">
                            <div class="shadow mb-4 mb-lg-0 w-100 rounded-bottom" style="width: 18rem;">
                                <img v-if="estate.image.length === 0" src="../assets/images/about-us/homeplus.jpg"
                                    class="card-img-top image-estate rounded-top" alt="..." title="">
                                <img v-else :src="estate.image[0].src" class="card-img-top image-estate rounded-top"
                                    alt="..." title="">
                                <div class="card-body p-3">
                                    <p class="card-text fw-bold">
                                    <p class="text-dark">
                                        {{ estate.description.substring(0, 60) }}&nbsp&nbsp...
                                    </p>
                                    </p>
                                </div>
                                <div class="d-flex p-2 gap">
                                    <span v-if="estate.transaction_type" class="text-muted">
                                        {{ getTransactionType(estate.transaction_type) }}
                                    </span>
                                    <span v-if="estate.estate_type" class="text-muted">
                                        {{ getEstateType(estate.estate_type) }}
                                    </span>
                                    <span v-if="estate.direction" class="text-muted">
                                        {{ getDirection(estate.direction) }}
                                    </span>
                                    <span v-if="estate.region" class="text-muted">
                                        {{ getRegion(estate.region) }}
                                    </span>
                                </div>
                            </div>
                        </router-link>
                    </div>
                    <div class="col-sm-6 col-lg-4 mb-4 d-flex justify-content-center align-items-center">
                        <div v-if="isPaginateLoading" class="lds-ellipsis">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    </div>
                    <div ref="infinitescrolltrigger" id="scroll-trigger"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Observer from "vue-intersection-observer";

export default {
  name: "RealEstate",
  components: {
    Observer,
  },
  data() {
    return {
      estates: [],
      isFirstLoading: true,
      isPaginateLoading: false,
      page: 1,
      visible: false,
    };
  },
  computed: {
    pageCount() {
      return Math.ceil(this.totalResults / this.maxPerPage);
    },
    pageOffset() {
      return this.maxPerPage * this.currentPage;
    },
  },
  methods: {
    onChange(entry) {
      this.visible = entry.isIntersecting;
    },
    getEstates() {
      this.axios
        .get("https://api.amlakplus.app/haghi-estate?page=" + this.page)
        .then((res) => {
          if (res.status === 200) {
            this.estates.push(...res.data.data);
            this.isFirstLoading = false;
          }
        });
    },
    getTransactionType(value) {
      if (value === "SALE") {
        return "خرید و فروش";
      } else if (value === "RENT") {
        return "رهن و اجاره";
      } else if (value === "PARTNERSHIP") {
        return "مشارکت";
      }
    },
    getEstateType(value) {
      if (value === "VILLA") {
        return "ویلایی";
      } else if (value === "APARTMENT") {
        return "آپارتمان";
      } else if (value === "EARTH") {
        return "زمین";
      }
    },
    getDirection(value) {
      if (value === "WEST") {
        return "غربی";
      } else if (value === "EAST") {
        return "شرق";
      } else if (value === "NORTH") {
        return "شمال";
      } else if (value === "SOUTH") {
        return "جنوب";
      }
    },
    getRegion(value) {
      return value.name;
    },
    getImage(value) {
      return value.src;
    },
    incrementPage() {
      this.page++;
    },
  },
  mounted() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio > 0) {
          this.isPaginateLoading = true;
          setTimeout(() => {
            this.page += 1;
            this.getEstates();
            this.isPaginateLoading = false;
          }, 2000);
        }
      });
    });
    observer.observe(this.$refs.infinitescrolltrigger);
    this.getEstates();
  },
  watch: {
    page(oldValue, newValue) {
      this.getEstates();
    },
  },
};
</script>